import { createFileRoute } from '@tanstack/react-router';

import { getAgreementQueryOptions } from '@/_pages/agreements/api-service';
import Loading from '@/_pages/agreements/paperwork/loading';

export const Route = createFileRoute('/_private/agreements/_template/$id/paperwork')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAgreementQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Paper Work',
    tabKey: 'agreement/paperwork',
  },
  pendingComponent: Loading,
});
